/** @jsxImportSource @emotion/react */

import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { OUT_OF_STOCK } from 'constants/stock-status'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { Button } from 'ui-components/Button'
import { Alert } from 'ui-components/Alert'
import {
  ItemContainer,
  InfoContainer,
  OptionsContainer,
  warning,
} from './styles'

export default function Item(props) {
  const {
    item,
    onEdit,
    onDelete,
    onConfirmOutOfStock,
    updating,
    preview,
  } = props

  const handleEdit = () => {
    onEdit(item)
  }

  const handleDelete = () => {
    onDelete(item)
  }

  const handleConfirmOutOfStock = () => {
    onConfirmOutOfStock(item.id)
  }

  const renderOutOfStock = () => (
    <Alert severity="error">
      Produto sem estoque disponível. Permitir que o produto fique com estoque negativo?
      <div>
        <Button
          color="primary"
          variant="text"
          onClick={handleDelete}
          disabled={updating}
        >
          Remover este item
        </Button>
        <Button
          color="secondary"
          variant="text"
          onClick={handleConfirmOutOfStock}
          disabled={updating}
        >
          Permitir
        </Button>
      </div>
    </Alert>
  )

  return (
    <ItemContainer css={item.stock === OUT_OF_STOCK ? warning : null}>
      <InfoContainer>
        <DescItemInfo label="Produto">
          {item.item.name}
        </DescItemInfo>

        <div className="item-attributes">
          <div className="qtt-value">
            <DescItemInfo label="Qtd.">
              {item.quantity}
            </DescItemInfo>

            <DescItemInfo label="Unidade">
              {currencyFormat(item.value, 'R$ ')}
            </DescItemInfo>
          </div>

          <div className="values">
            <DescItemInfo label="Desconto">
              {currencyFormat(item.discount_value, 'R$ ')}
            </DescItemInfo>

            <DescItemInfo label="Total">
              {currencyFormat(item.total_value, 'R$ ')}
            </DescItemInfo>
          </div>

          <OptionsContainer>
            <Button
              disabled={preview}
              buttonType="icon"
              onClick={handleDelete}
              size="small"
            >
              <DeleteIcon fontSize="small" />
            </Button>

            <Button
              disabled={preview}
              buttonType="icon"
              onClick={handleEdit}
              size="small"
            >
              <EditIcon fontSize="small" />
            </Button>
          </OptionsContainer>
        </div>
      </InfoContainer>

      { item.stock === OUT_OF_STOCK ? renderOutOfStock() : null }
    </ItemContainer>
  )
}

Item.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onConfirmOutOfStock: PropTypes.func.isRequired,
  updating: PropTypes.bool,
  preview: PropTypes.bool,
}

Item.defaultProps = {
  updating: false,
  preview: false,
}
